import clsx from 'clsx'

import { ChevronDownIcon, ChevronUpIcon, Table } from '@buffer-mono/popcorn'

import styles from './SortableHeaderCell.module.css'

import type { JSX } from 'react'

interface SortableHeaderCellProps {
  label: string
  sortKey: string
  activeSortKey: string
  sortDirection: string
  onSort: (key: string) => void
}

export function SortableHeaderCell({
  label,
  sortKey,
  activeSortKey,
  sortDirection,
  onSort,
}: SortableHeaderCellProps): JSX.Element {
  const isActive = activeSortKey === sortKey
  const ariaSort = isActive
    ? sortDirection === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none'

  return (
    <Table.HeaderCell align="left" aria-sort={ariaSort}>
      <button
        type="button"
        className={clsx(styles.sortButton, isActive && styles.sortButtonActive)}
        onClick={() => onSort(sortKey)}
        aria-label={`Sort by ${label}${
          isActive
            ? `, currently ${
                sortDirection === 'asc' ? 'ascending' : 'descending'
              }`
            : ''
        }`}
      >
        {label}
        {isActive ? (
          sortDirection === 'asc' ? (
            <ChevronUpIcon size="xsmall" />
          ) : (
            <ChevronDownIcon size="xsmall" />
          )
        ) : (
          <ChevronDownIcon size="xsmall" className={styles.sortIconInactive} />
        )}
      </button>
    </Table.HeaderCell>
  )
}
